/* ============================================================
   Othon Schmitt — Theme JS
   ============================================================ */

(function () {
  function initDrawer() {
    var drawer = document.getElementById('drawer');
    var scrim  = document.getElementById('drawerScrim');
    var opener = document.getElementById('menuOpen');
    var closer = document.getElementById('menuClose');
    if (!drawer || !opener) return;

    function setOpen(open) {
      drawer.classList.toggle('open', open);
      if (scrim) scrim.classList.toggle('open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    opener.addEventListener('click', function () { setOpen(true); });
    if (closer) closer.addEventListener('click', function () { setOpen(false); });
    if (scrim)  scrim.addEventListener('click',  function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    drawer.addEventListener('click', function (e) {
      var trigger = e.target.closest('.drawer-accordion-trigger');
      if (!trigger || !drawer.contains(trigger)) return;
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) panel.setAttribute('hidden', '');
      else panel.removeAttribute('hidden');
    });
  }

  function initPromoBanner() {
    try {
      if (localStorage.getItem('promoDismissed') === '1') {
        var b = document.getElementById('promoBanner');
        if (b) b.style.display = 'none';
      }
    } catch (e) { /* ignore */ }

    var close = document.querySelector('#promoBanner .promo-close');
    if (close) {
      close.addEventListener('click', function () {
        var b = document.getElementById('promoBanner');
        if (b) b.style.display = 'none';
        try { localStorage.setItem('promoDismissed', '1'); } catch (e) {}
      });
    }
  }

  function initNavMenus() {
    var groups = document.querySelectorAll('.has-mega, .has-dropdown');
    if (!groups.length) return;

    var OPEN_DELAY  = 80;
    var CLOSE_DELAY = 280;

    function panelFor(group) {
      return group.querySelector('.mega-panel, .dropdown-panel');
    }

    function closeAll(except) {
      groups.forEach(function (g) {
        if (g === except) return;
        g.classList.remove('is-open');
        var t = g.querySelector('.nav-link');
        if (t) t.setAttribute('aria-expanded', 'false');
        clearTimeout(g._navOpenTimer);
        clearTimeout(g._navCloseTimer);
      });
    }

    function setOpen(group, open) {
      var trigger = group.querySelector('.nav-link');
      if (!trigger) return;
      clearTimeout(group._navOpenTimer);
      clearTimeout(group._navCloseTimer);
      if (open) {
        closeAll(group);
        group.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        group.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function scheduleOpen(group) {
      clearTimeout(group._navCloseTimer);
      clearTimeout(group._navOpenTimer);
      group._navOpenTimer = setTimeout(function () { setOpen(group, true); }, OPEN_DELAY);
    }

    function scheduleClose(group) {
      clearTimeout(group._navOpenTimer);
      clearTimeout(group._navCloseTimer);
      group._navCloseTimer = setTimeout(function () { setOpen(group, false); }, CLOSE_DELAY);
    }

    function isInsideMenu(node) {
      if (!node || !node.closest) return false;
      return !!(
        node.closest('.has-mega') ||
        node.closest('.has-dropdown') ||
        node.closest('.mega-panel') ||
        node.closest('.dropdown-panel')
      );
    }

    groups.forEach(function (group) {
      var trigger = group.querySelector('.nav-link');
      var panel   = panelFor(group);
      if (!trigger || !panel) return;

      [group, panel].forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          closeAll(group);
          scheduleOpen(group);
        });
        el.addEventListener('mouseleave', function (e) {
          if (isInsideMenu(e.relatedTarget)) return;
          scheduleClose(group);
        });
      });

      group.addEventListener('focusin', function () { setOpen(group, true); });
      group.addEventListener('focusout', function (e) {
        if (!group.contains(e.relatedTarget)) scheduleClose(group);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.has-mega.is-open, .has-dropdown.is-open, .has-mega:focus-within, .has-dropdown:focus-within');
      if (!open) return;
      closeAll();
      var active = document.activeElement;
      if (active && open.contains(active)) active.blur();
    });
  }

  function start() {
    initDrawer();
    initPromoBanner();
    initNavMenus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============ Collection filters & sort ============
   Color/region/type: client-side (metafields on cards) — products are not tagged,
   so /collections/x/rouge redirects and does nothing.
   Sort: server-side ?sort_by= (Shopify native).
*/
(function () {
  function initCollectionFilters() {
    var grid = document.getElementById('grid');
    var meta = document.getElementById('resultsMeta');
    var toolbar = document.querySelector('[data-collection-toolbar]');
    var sectionRoot = document.querySelector('[data-collection-section]');
    if (!grid) return;

    if (toolbar) toolbar.classList.add('js-on');

    var collectionBase = (sectionRoot && sectionRoot.getAttribute('data-collection-url')) ||
      window.location.pathname.replace(/\/+$/, '');

    var cardPool = null;
    var cardPoolPromise = null;
    var originalGridHTML = grid.innerHTML;
    var paginationEl = document.querySelector('.brand-pagination');

    function currentSort() {
      return new URLSearchParams(window.location.search).get('sort_by') || 'manual';
    }

    function sortParamFromUi(mode) {
      if (mode === 'price-asc') return 'price-ascending';
      if (mode === 'price-desc') return 'price-descending';
      if (mode === 'name') return 'title-ascending';
      return 'manual';
    }

    function uiFromSortParam(param) {
      if (param === 'price-ascending') return 'price-asc';
      if (param === 'price-descending') return 'price-desc';
      if (param === 'title-ascending') return 'name';
      return 'featured';
    }

    function totalPages() {
      var count = parseInt((sectionRoot && sectionRoot.getAttribute('data-products-count')) || '0', 10);
      var per = parseInt((sectionRoot && sectionRoot.getAttribute('data-per-page')) || '24', 10) || 24;
      if (!count) return 1;
      return Math.min(40, Math.max(1, Math.ceil(count / per)));
    }

    function isFiltering() {
      return state.color !== 'all' || state.region !== 'all' || state.type !== 'all';
    }

    function buildCollectionUrl(opts) {
      opts = opts || {};
      var url = new URL(collectionBase, window.location.origin);
      var sort = opts.sort != null ? opts.sort : currentSort();
      if (sort && sort !== 'manual') url.searchParams.set('sort_by', sort);
      var color = opts.color != null ? opts.color : state.color;
      var region = opts.region != null ? opts.region : state.region;
      var type = opts.type != null ? opts.type : state.type;
      if (color && color !== 'all') url.searchParams.set('color', color);
      if (region && region !== 'all') url.searchParams.set('region', region);
      if (type && type !== 'all') url.searchParams.set('type', type);
      return url;
    }

    function syncUrlParams() {
      var url = buildCollectionUrl();
      history.replaceState({}, '', url.pathname + url.search);
    }

    var state = { color: 'all', type: 'all', region: 'all' };
    (function syncStateFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var color = (params.get('color') || '').toLowerCase();
      var region = (params.get('region') || '').toLowerCase();
      var type = (params.get('type') || '').toLowerCase();
      var colorMap = { rouge: 'red', red: 'red', blanc: 'white', white: 'white', rose: 'rose', other: 'other' };
      var typeMap = { whisky: 'whisky', whiskey: 'whisky', rhum: 'rhum', rum: 'rhum', cognac: 'cognac' };
      if (colorMap[color]) state.color = colorMap[color];
      if (region) state.region = region;
      if (typeMap[type]) state.type = typeMap[type];
      else if (type) state.type = type;
    })();

    function cardMatches(el) {
      if (state.color !== 'all' && (el.getAttribute('data-color') || '') !== state.color) return false;
      if (state.region !== 'all' && (el.getAttribute('data-region') || '') !== state.region) return false;
      if (state.type !== 'all') {
        var cat = (el.getAttribute('data-cat') || '').toLowerCase();
        if (cat !== state.type && cat.indexOf(state.type) === -1) return false;
      }
      return true;
    }

    function updateCount(n) {
      if (!meta) return;
      var template = (window.themeStrings && window.themeStrings.resultsCount) || '__COUNT__ résultats';
      if (typeof template === 'object' && template) {
        template = (n === 1 ? template.one : template.other) || template.other || '__COUNT__ résultats';
      }
      meta.textContent = String(template).replace(/__COUNT__/g, String(n)).replace(/\{\{\s*count\s*\}\}/g, String(n));
      var live = document.getElementById('screenLive');
      if (live) live.textContent = meta.textContent;
    }

    function loadAllCards() {
      if (cardPool) return Promise.resolve(cardPool);
      if (cardPoolPromise) return cardPoolPromise;

      var pages = totalPages();
      var sort = currentSort();
      var fetches = [];
      for (var p = 1; p <= pages; p++) {
        (function (page) {
          var url = collectionBase + '?page=' + page;
          if (sort && sort !== 'manual') url += '&sort_by=' + encodeURIComponent(sort);
          fetches.push(
            fetch(url, { credentials: 'same-origin' })
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                return Array.prototype.slice.call(doc.querySelectorAll('#grid .product'));
              })
              .catch(function () { return []; })
          );
        })(p);
      }

      cardPoolPromise = Promise.all(fetches).then(function (groups) {
        var seen = {};
        cardPool = [];
        groups.forEach(function (arr) {
          arr.forEach(function (el) {
            var href = el.getAttribute('href') || '';
            if (seen[href]) return;
            seen[href] = true;
            cardPool.push(el);
          });
        });
        return cardPool;
      });
      return cardPoolPromise;
    }

    function applyClientFilters() {
      syncUrlParams();
      renderActiveFilters();
      updateActiveCount();

      if (!isFiltering()) {
        grid.innerHTML = originalGridHTML;
        if (paginationEl) paginationEl.style.display = '';
        var baseCount = (sectionRoot && sectionRoot.getAttribute('data-products-count')) || grid.querySelectorAll('.product').length;
        updateCount(baseCount);
        return;
      }

      grid.classList.add('loading');
      loadAllCards()
        .then(function (pool) {
          var matched = pool.filter(cardMatches);
          grid.innerHTML = '';
          matched.forEach(function (el) {
            grid.appendChild(el.cloneNode(true));
          });
          updateCount(matched.length);
          if (paginationEl) paginationEl.style.display = 'none';
          grid.classList.remove('loading');
        })
        .catch(function () {
          var visible = 0;
          grid.querySelectorAll('.product').forEach(function (el) {
            var ok = cardMatches(el);
            el.style.display = ok ? '' : 'none';
            if (ok) visible++;
          });
          updateCount(visible);
          if (paginationEl) paginationEl.style.display = 'none';
          grid.classList.remove('loading');
        });
    }

    function setFilterValue(stateKey, val, valueEl, opt) {
      state[stateKey] = val || 'all';
      if (valueEl && opt) {
        var clone = opt.cloneNode(true);
        var countNode = clone.querySelector('.dd-count');
        if (countNode) countNode.remove();
        valueEl.textContent = clone.textContent.trim();
      }
      applyClientFilters();
    }

    function wireDropdown(triggerId, panelId, valueId, stateKey) {
      var trigger = document.getElementById(triggerId);
      var panel = document.getElementById(panelId);
      var valueEl = document.getElementById(valueId);
      if (!trigger || !panel) return;

      function setOpen(open) {
        trigger.classList.toggle('open', open);
        panel.classList.toggle('open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      document.addEventListener('click', function (e) {
        var opt = e.target.closest('.dd-option');
        if (opt && panel.contains(opt)) {
          panel.querySelectorAll('.dd-option').forEach(function (o) {
            o.classList.remove('active');
          });
          opt.classList.add('active');
          var val = opt.dataset.filter || opt.dataset.region || opt.dataset.type || 'all';
          setOpen(false);
          setFilterValue(stateKey, val, valueEl, opt);
          return;
        }
        if (e.target.closest('#' + triggerId)) {
          setOpen(!panel.classList.contains('open'));
          return;
        }
        if (!panel.contains(e.target)) setOpen(false);
      });
    }

    wireDropdown('filterTrigger', 'filterPanel', 'filterValue', 'color');
    wireDropdown('regionTrigger', 'regionPanel', 'regionValue', 'region');
    wireDropdown('typeTrigger', 'typePanel', 'typeValue', 'type');

    document.querySelectorAll('#chips .chip').forEach(function (chip) {
      // Collection chips are real links — let the browser navigate.
      if (chip.tagName === 'A') return;
      chip.addEventListener('click', function () {
        document.querySelectorAll('#chips .chip').forEach(function (c) {
          c.classList.remove('active');
        });
        chip.classList.add('active');
        state.type = chip.dataset.filter || 'all';
        applyClientFilters();
      });
    });

    var ts = window.themeStrings || {};
    var FILTERS = [
      { panel: 'filterPanel', value: 'filterValue', cat: ts.filterCatColor || 'Filter', key: 'color', dataAttr: 'filter' },
      { panel: 'typePanel', value: 'typeValue', cat: ts.filterCatType || 'Filter', key: 'type', dataAttr: 'type' },
      { panel: 'regionPanel', value: 'regionValue', cat: ts.filterCatRegion || 'Region', key: 'region', dataAttr: 'region' }
    ];

    function updateActiveCount() {
      var n = 0;
      if (state.color !== 'all') n++;
      if (state.type !== 'all') n++;
      if (state.region !== 'all') n++;
      var badge = document.querySelector('[data-active-filter-count]');
      if (badge) {
        if (n > 0) {
          badge.textContent = String(n);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    }

    function renderActiveFilters() {
      var strip = document.querySelector('.active-filters');
      if (!strip) {
        strip = document.createElement('div');
        strip.className = 'active-filters';
        var gw = document.querySelector('.grid-wrap');
        if (gw) gw.parentNode.insertBefore(strip, gw);
      }
      strip.innerHTML = '';
      var active = [];

      FILTERS.forEach(function (f) {
        var panelEl = document.getElementById(f.panel);
        if (!panelEl) return;
        var opt = panelEl.querySelector('.dd-option.active');
        if (!opt) return;
        var filterVal = opt.dataset[f.dataAttr];
        if (!filterVal || filterVal === 'all') return;
        var labelEl = opt.querySelector('span');
        var label = labelEl
          ? labelEl.textContent.trim().replace(/\s+\d+$/, '')
          : '';
        active.push({ f: f, opt: opt, label: label, panelEl: panelEl });
      });

      if (!active.length) {
        updateActiveCount();
        return;
      }

      var labelNode = document.createElement('span');
      labelNode.className = 'label';
      labelNode.textContent =
        (window.themeStrings && window.themeStrings.activeLabel) || 'Active filters';
      strip.appendChild(labelNode);

      active.forEach(function (a) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'filter-pill';
        pill.innerHTML =
          '<span class="pill-cat">' +
          a.f.cat +
          '</span><span>' +
          a.label +
          '</span><span class="x" aria-label="Remove">×</span>';
        pill.addEventListener('click', function () {
          var allOpt = a.panelEl.querySelector(
            '.dd-option[data-' + a.f.dataAttr + '="all"]'
          );
          if (allOpt) allOpt.click();
        });
        strip.appendChild(pill);
      });

      if (active.length >= 2) {
        var clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'clear-all';
        clear.textContent =
          (window.themeStrings && window.themeStrings.clearAll) || 'Clear all';
        clear.addEventListener('click', function () {
          state.color = 'all';
          state.type = 'all';
          state.region = 'all';
          FILTERS.forEach(function (f) {
            var panelEl = document.getElementById(f.panel);
            if (!panelEl) return;
            panelEl.querySelectorAll('.dd-option').forEach(function (o) {
              o.classList.toggle('active', (o.dataset[f.dataAttr] || 'all') === 'all');
            });
            var valueEl = document.getElementById(f.value);
            var allOpt = panelEl.querySelector('.dd-option[data-' + f.dataAttr + '="all"]');
            if (valueEl && allOpt) {
              var clone = allOpt.cloneNode(true);
              var countNode = clone.querySelector('.dd-count');
              if (countNode) countNode.remove();
              valueEl.textContent = clone.textContent.trim();
            }
          });
          document.querySelectorAll('#chips .chip').forEach(function (chip) {
            chip.classList.toggle('active', (chip.dataset.filter || 'all') === 'all');
          });
          applyClientFilters();
        });
        strip.appendChild(clear);
      }
      updateActiveCount();
    }

    function navigateWithSort(uiMode) {
      cardPool = null;
      cardPoolPromise = null;
      var url = buildCollectionUrl({ sort: sortParamFromUi(uiMode) });
      window.location.href = url.pathname + url.search;
    }

    function applySort(value, label) {
      var sortSelect = document.getElementById('collectionSort');
      var sortDisplay = document.querySelector('[data-sort-value-display]');
      var sortPanel = document.getElementById('sortPanel');
      if (sortSelect) sortSelect.value = value;
      if (sortDisplay && label) sortDisplay.textContent = label;
      if (sortPanel) {
        sortPanel.querySelectorAll('.sort-option').forEach(function (opt) {
          var on = opt.dataset.sortValue === value;
          opt.setAttribute('aria-selected', on ? 'true' : 'false');
          var check = opt.querySelector('.sort-check');
          if (check) check.textContent = on ? '✓' : '';
        });
      }
      document.querySelectorAll('.sheet-sort-option').forEach(function (opt) {
        var on = opt.dataset.sortValue === value;
        opt.setAttribute('aria-checked', on ? 'true' : 'false');
        var check = opt.querySelector('.sort-check');
        if (check) check.textContent = on ? '✓' : '';
      });
      var sheetSortLabel = document.querySelector('[data-sheet-sort-label]');
      if (sheetSortLabel && label) sheetSortLabel.textContent = label;
      navigateWithSort(value);
    }

    function wireSortDropdown() {
      var sortDd = document.querySelector('[data-sort-dropdown]');
      var sortTrigger = document.getElementById('sortTrigger');
      var sortPanel = document.getElementById('sortPanel');
      if (!sortDd || !sortTrigger || !sortPanel) return;

      function setSortOpen(open) {
        sortTrigger.classList.toggle('open', open);
        sortPanel.classList.toggle('open', open);
        sortTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      document.addEventListener('click', function (e) {
        var opt = e.target.closest('.sort-option');
        if (opt && sortPanel.contains(opt)) {
          applySort(opt.dataset.sortValue, opt.querySelector('span') ? opt.querySelector('span').textContent.trim() : '');
          setSortOpen(false);
          return;
        }
        if (e.target.closest('#sortTrigger')) {
          setSortOpen(!sortPanel.classList.contains('open'));
          return;
        }
        if (!sortDd.contains(e.target)) setSortOpen(false);
      });
    }

    function wireFilterSheet() {
      var sheet = document.getElementById('filterSheet');
      if (!sheet) return;

      function openSheet() {
        sheet.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var trigger = document.querySelector('[data-sheet-open]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
      function closeSheet() {
        sheet.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        var trigger = document.querySelector('[data-sheet-open]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }

      function syncSheetOption(target, value, labelEl, labelText) {
        sheet.querySelectorAll('[data-sheet-target="' + target + '"]').forEach(function (btn) {
          btn.classList.toggle('active', btn.dataset.sheetFilter === value);
        });
        var panelId = target === 'color' ? 'filterPanel' : 'regionPanel';
        var valueId = target === 'color' ? 'filterValue' : 'regionValue';
        var dataAttr = target === 'color' ? 'filter' : 'region';
        var panel = document.getElementById(panelId);
        if (panel) {
          panel.querySelectorAll('.dd-option').forEach(function (opt) {
            opt.classList.toggle('active', (opt.dataset[dataAttr] || 'all') === value);
          });
          var activeOpt = panel.querySelector('.dd-option[data-' + dataAttr + '="' + value + '"]');
          var valueEl = document.getElementById(valueId);
          if (valueEl && activeOpt) {
            var clone = activeOpt.cloneNode(true);
            var countNode = clone.querySelector('.dd-count');
            if (countNode) countNode.remove();
            valueEl.textContent = clone.textContent.trim();
          }
        }
        if (labelEl && labelText) labelEl.textContent = labelText;
      }

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-sheet-open]')) {
          openSheet();
          return;
        }
        if (e.target.closest('[data-sheet-close]')) {
          closeSheet();
          return;
        }
        var sheetOpt = e.target.closest('[data-sheet-filter]');
        if (sheetOpt && sheet.contains(sheetOpt)) {
          var target = sheetOpt.dataset.sheetTarget;
          var val = sheetOpt.dataset.sheetFilter;
          var label = sheetOpt.textContent.replace(/\s+\d+$/, '').trim();
          if (target === 'color') {
            state.color = val;
            syncSheetOption('color', val, document.querySelector('[data-sheet-color-label]'), label);
          } else if (target === 'region') {
            state.region = val;
            syncSheetOption('region', val, document.querySelector('[data-sheet-region-label]'), label);
          }
          applyClientFilters();
          return;
        }
        var sheetSort = e.target.closest('.sheet-sort-option');
        if (sheetSort && sheet.contains(sheetSort)) {
          var sortLabel = sheetSort.textContent.replace('✓', '').trim();
          applySort(sheetSort.dataset.sortValue, sortLabel);
          return;
        }
        if (e.target.closest('[data-sheet-clear]')) {
          state.color = 'all';
          state.region = 'all';
          state.type = 'all';
          syncSheetOption('color', 'all', document.querySelector('[data-sheet-color-label]'), null);
          syncSheetOption('region', 'all', document.querySelector('[data-sheet-region-label]'), null);
          applyClientFilters();
        }
      });

      sheet.querySelectorAll('.sheet-acc-trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (!panel) return;
          var open = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) panel.setAttribute('hidden', '');
          else panel.removeAttribute('hidden');
        });
      });
    }

    wireSortDropdown();
    wireFilterSheet();

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.dd-panel.open').forEach(function (p) {
          p.classList.remove('open');
        });
        document.querySelectorAll('.dd-trigger.open').forEach(function (t) {
          t.classList.remove('open');
        });
      }
    });

    (function syncFilterUi() {
      function activate(panelId, attr, value) {
        var panel = document.getElementById(panelId);
        if (!panel) return;
        panel.querySelectorAll('.dd-option').forEach(function (opt) {
          var v = opt.getAttribute('data-' + attr) || opt.dataset[attr] || 'all';
          opt.classList.toggle('active', v === value);
        });
        var valueEl = document.getElementById(panelId === 'filterPanel' ? 'filterValue' : panelId === 'regionPanel' ? 'regionValue' : 'typeValue');
        var active = panel.querySelector('.dd-option.active');
        if (valueEl && active) {
          var clone = active.cloneNode(true);
          var countNode = clone.querySelector('.dd-count');
          if (countNode) countNode.remove();
          valueEl.textContent = clone.textContent.trim();
        }
      }
      activate('filterPanel', 'filter', state.color);
      activate('regionPanel', 'region', state.region);
      activate('typePanel', 'type', state.type);
      document.querySelectorAll('#chips .chip').forEach(function (chip) {
        chip.classList.toggle('active', (chip.dataset.filter || 'all') === state.type);
      });
    })();

    (function syncSortUi() {
      var ui = uiFromSortParam(currentSort());
      var opt = document.querySelector('.sort-option[data-sort-value="' + ui + '"] span');
      var label = opt ? opt.textContent.trim() : '';
      var sortSelect = document.getElementById('collectionSort');
      var sortDisplay = document.querySelector('[data-sort-value-display]');
      if (sortSelect) sortSelect.value = ui;
      if (sortDisplay && label) sortDisplay.textContent = label;
      document.querySelectorAll('.sort-option, .sheet-sort-option').forEach(function (o) {
        var on = o.dataset.sortValue === ui;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        var check = o.querySelector('.sort-check');
        if (check) check.textContent = on ? '✓' : '';
      });
    })();

    if (isFiltering()) {
      applyClientFilters();
    } else {
      renderActiveFilters();
      updateActiveCount();
    }
  }

  window.sortGrid = function (mode) {
    var sectionRoot = document.querySelector('[data-collection-section]');
    var collectionBase = (sectionRoot && sectionRoot.getAttribute('data-collection-url')) ||
      window.location.pathname.replace(/\/+$/, '');
    var params = new URLSearchParams(window.location.search);
    var sortMap = {
      'price-asc': 'price-ascending',
      'price-desc': 'price-descending',
      name: 'title-ascending',
      featured: 'manual'
    };
    var sort = sortMap[mode] || 'manual';
    var url = new URL(collectionBase, window.location.origin);
    if (sort && sort !== 'manual') url.searchParams.set('sort_by', sort);
    ['color', 'region', 'type'].forEach(function (key) {
      var v = params.get(key);
      if (v) url.searchParams.set(key, v);
    });
    window.location.href = url.pathname + url.search;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilters);
  } else {
    initCollectionFilters();
  }
})();
